export default "__VITE_ASSET__CSYP4VpP__"